import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadBaseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.75 13.875H14.25V15.375H3.75V13.875Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M6.3075 7.5675L5.25 8.625L9 12.375L12.75 8.625L11.6925 7.5675L9.75 9.5025V2.625H8.25V9.5025L6.3075 7.5675Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDownloadBaseIcon);
export { ForwardRef as ReactComponent };
